import beeps from "../sound/bright-ringtone-loop-151768.mp3";

export const soundList: { [key: string]: string } = {
  beeps,
};
